import { render, staticRenderFns } from "./Kepegawaian.vue?vue&type=template&id=2d4f0bc1"
import script from "./Kepegawaian.vue?vue&type=script&lang=js"
export * from "./Kepegawaian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports